__turbopack_context__.v({
  "button": "CreateWalletSuccess-module__00EI-a__button",
  "buttonWrapper": "CreateWalletSuccess-module__00EI-a__buttonWrapper",
  "icon": "CreateWalletSuccess-module__00EI-a__icon",
  "root": "CreateWalletSuccess-module__00EI-a__root",
});
